import { Navigate, Outlet, useLocation } from 'react-router-dom';
import React from 'react';
import Cookies from 'js-cookie';

const ProtectedRouteSetup = ({ allowedRole, redirectTo }) => {
  // let role = sessionStorage.getItem('role');
  let role = Cookies.get('role');
  const location = useLocation();
  const branchCode = Cookies.get('branchCode');
  const companyCode = Cookies.get('companyCode');
  const currentPath = location.pathname;

  const openRoutes = ['/userwise/branch/list/', '/userwise/company/list/'];
  const isRoleAllowed = allowedRole.includes(role);
  const isOpenRoute = openRoutes.includes(currentPath);

  // If the role is not allowed, redirect to the specified route
  if (!isRoleAllowed || ((!branchCode || !companyCode) && !isOpenRoute)) {
    return <Navigate to={redirectTo} />;
  }

  // Otherwise, render children routes
  return <Outlet />;
};

export default ProtectedRouteSetup;
